import { DotsHorizontalIcon } from "@heroicons/react/solid";
import moment from "moment";
import React, { useContext } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import ReactShowMoreText from "react-show-more-text";
import { serverInfo } from "../../../../../../App";
import noImage from "../../../../../../Assets/Images/no-image.png";
import FanPostReaction from "./FanPostReaction";
import Linkify from "react-linkify";
const FanpostComponent = ({ userId, post }) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  return (
    <>
      <div className="container PostWidth align-items-center justify-content-center  Enroll-Auditions">
        <div className="card PostCardBg ">
          <h2 className="accordion-header PostBack">
            <div className="d-flex justify-content-between">
              <div className="accordion-button-fx profile1-accordion-button PostBack  collapsed">
                <img
                  src={
                    post?.user?.image !== null
                      ? imageCdnUrl + post?.user?.image
                      : noImage
                  }
                  className="PostImgHome"
                  alt="star-profile"
                />
                <span className="mx-2 text-warning text-light">
                  <Link className="link-starPorfile">
                    {post.user?.first_name} {post.user?.last_name}
                  </Link>
                  <br></br>
                  <small className="category-size-chat">
                    {moment(post.created_at).format("LT")}&nbsp;|&nbsp;
                  </small>
                  <small className="category-size-chat">
                    {moment(post.created_at).format("LL")}
                  </small>
                  <small
                    className="category-size-chat"
                    style={{ fontSize: "13px", paddingLeft: "15px" }}
                  >
                    Fan of {post.star?.first_name} {post.star?.last_name}
                  </small>
                </span>
              </div>
            </div>
          </h2>

          <ReactShowMoreText
            lines={3}
            more={<span>See more</span>}
            less={<span>See less</span>}
            className="content-css my-2 Enroll-a Enroll-text py-2"
            anchorClass="my-anchor-css-class"
            expanded={false}
            truncatedEndingComponent={"... "}
          >
            <Linkify properties={{ target: "_blank" }}>
              {post.description}
            </Linkify>
          </ReactShowMoreText>

          <div className="ViewPost">
            <div className=" card  border-0 containerPost">
              {post?.image || post?.video !== null ? (
                <>
                  {post?.image ? (
                    <img src={imageCdnUrl + post?.image} alt="" />
                  ) : (
                    <ReactPlayer
                      url={videoCdnUrl + post?.video}
                      width="100%"
                      controls="true"
                    />
                  )}
                </>
              ) : (
                <></>
              )}
            </div>

            <FanPostReaction post={post}></FanPostReaction>
          </div>
        </div>
      </div>
    </>
  );
};

export default FanpostComponent;
